export enum SexEnum {
    FEMALE = 0,
    MALE = 1,
}

export const SexBarrierEnum = {
  ALWAYS: "always",
  SOMETIMES: "sometimes",
  NEVER: "never",
};

export const PartnersRangeEnum = {
  ZERO: "zero",
  ONE: "one",
  TWO_FIVE: "two_five",
  SIX_TEN: "six_ten",
  ABOVE_TEN: "above_ten",
};
